<footer class="footer">
    <p class="mb-0 mx-2 fz-14 text-center">
        <span *ngIf="customerTitle">Copyright © {{year}} {{customerTitle}}</span>
        <span class="float-right" *ngIf="isWhiteLabled == 'No'">
            Powered By <a [href]="footerLink ? footerLink : 'https://www.staffinggo.in/'" target="_blank">{{footerText ? footerText : 'StaffingGo'}}</a>
        </span>
    </p>
</footer>